<template>
  <div
      style="display: flex; justify-content: center"
  >
    <tableau-embedded
        v-if="tableauId !== null"
        :tableauId="tableauId"
        isCorpTableau="true"
    >
    </tableau-embedded>

  </div>

</template>

<script>
import TableauEmbedded from "../../TableauEmbedded";

export default {
  name: "TableauComponent",
  props: {
    tableauId: {
      type: String,
      default() { return 'theme_transportation_subway_seoul/daily_variation_01' }
    }
  },
  components: {
    TableauEmbedded
  }
}
</script>

<style scoped>

</style>
